export default __webpack_public_path__ + "static/media/cage-length-grey.ed55f19e.svg";